import React from "react";
import styled from "styled-components";

import { COLORS } from "../../../../../constants";

type ModalButtonVariant = "primary" | "danger";

const StyledButton = styled.button<{ $variant: ModalButtonVariant }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 14px;
  padding: 4px 15px;
  cursor: pointer;
  color: ${COLORS.white};
  border: 1px solid ${({ $variant }) => ($variant === "danger" ? COLORS.red : COLORS.coeblue4)};
  background-color: ${({ $variant }) => ($variant === "danger" ? COLORS.red : COLORS.coeblue4)};
  transition: background-color 0.2s, border-color 0.2s, filter 0.2s;

  &:hover {
    ${({ $variant }) =>
      $variant === "danger"
        ? "filter: brightness(0.92);"
        : `
          background-color: ${COLORS.coeblue6};
          border-color: ${COLORS.coeblue6};
        `}
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

interface ModalButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ModalButtonVariant;
}

export const ModalButton: React.FC<ModalButtonProps> = ({ variant = "primary", ...props }) => (
  <StyledButton type="button" $variant={variant} {...props} />
);
